import React, { useEffect, useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';

const indiaTime = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Kolkata', hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true,
});
const indiaDate = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kolkata', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
});
const indiaHour = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', hour: 'numeric', hourCycle: 'h23' });

function WelcomeBanner({ name }) {
    const [now, setNow] = useState(() => new Date());
    useEffect(() => {
        const timer = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);
    const hour = Number(indiaHour.format(now));
    const greeting = hour < 12 ? 'Good Morning' : hour < 17 ? 'Good Afternoon' : 'Good Evening';
    return <section className="crm-welcome" aria-label="Dashboard welcome">
        <div className="crm-welcome-copy">
            <span className="crm-panel-badge">LEAD PUSH PANEL</span>
            <h1>Welcome back, <span>{name}</span></h1>
            <p>{greeting}</p>
        </div>
        <div className="crm-clock" aria-label="Live clock, India Standard Time">
            <span className="crm-clock-label">LIVE CLOCK</span>
            <time dateTime={now.toISOString()}>{indiaTime.format(now)}</time>
            <span className="crm-clock-date">{indiaDate.format(now)}</span>
            <span className="crm-clock-status"><i aria-hidden="true" /> Live time</span>
        </div>
    </section>;
}

export default function Dashboard() {
    return <DashboardLayout>{user => <WelcomeBanner name={user.subadmin_name} />}</DashboardLayout>;
}
